/**
 * Which hand the weapon is in.
 *
 * "Додай в налаштування, щоб можна було вибрати, в якій руці тримати
 * зброю." A preference about the person rather than about any one world,
 * so it is kept beside the music and the language and not in a save. The
 * shield goes in the other hand; nothing else about the game changes.
 */
export type Hand = "right" | "left";

/** Where the browser keeps it. */
export const HAND_KEY = "vyzhyvannia.hand";

/** Read a kept value back, with the right hand for anything that is not a hand. */
export function parseHand(value: unknown): Hand {
  return value === "left" ? "left" : "right";
}
